import Chip from '@mui/material/Chip'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import React from 'react'

// import { Container } from './styles';

const OperacaoChip: React.FC<GridCellParams> = ({ value }) => {
    return (
        <Chip
            label={value}
            sx={{
                width: '100%',
                fontWeight: 'bold',
                color: value === 'READ' ? 'default' : 'white',
            }}
            color={
                value === 'READ'
                    ? 'default'
                    : value === 'LOGIN'
                      ? 'primary'
                      : value === 'INSERT'
                        ? 'success'
                        : value === 'UPDATE'
                          ? 'info'
                          : value === 'DELETE'
                            ? 'warning'
                            : 'error'
            }
        />
    )
}

export default OperacaoChip
